import React, {PureComponent} from "react"
import moment from "moment"
import PropTypes from "prop-types"
import styled from "styled-components"

import IconText from "@irati/ui/src/IconText"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import {IconTypes} from "@irati/ui/src/Icon"

const MarginBottom = styled.div`
  margin-bottom: ${padding.tiny};
`

class DateWarning extends PureComponent {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    endDate: PropTypes.object,
    minDate: PropTypes.object
  }

  static defaultProps = {
    endDate: moment().hours(17).minutes(0).seconds(0),
    minDate: moment().hours(9).minutes(0).seconds(0)
  }

  getHint = () => {
    const {poll, minDate, endDate, intl} = this.props
    if (!poll.endsAt) {
      return null
    }
    const test = moment(poll.endsAt)
    const now = moment()
    if (minDate < now && test <= endDate) {
      return <FormattedMessage
        id="recognition.popup.createPoll.shared.dateWarning"
        values={{when: intl.formatRelative(poll.endsAt)}} />
    }
    return null
  }

  render() {
    const hint = this.getHint()
    if (!hint) {
      return null
    }

    return (
      <MarginBottom>
        <IconText icon={IconTypes.info}>
          {hint}
        </IconText>
      </MarginBottom>
    )
  }
}

export default injectIntl(DateWarning)
